import React, { useEffect, useState } from "react";
import { Container } from 'react-bootstrap';
import { CSSTransition } from 'react-transition-group';
import { Breadcrumbs } from "../Components/Breadcrumbs";
import { fetchAllGalleries } from '../Services/GalleryService';
import Image from '../Components/Image';
import '../assets/style.css';
import { Helmet } from "react-helmet-async";


const GalleryScreen = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [galleries, setGalleries] = useState([]);


    const getImages = async () => {
        await fetchAllGalleries(setGalleries);
    }

    useEffect(() => {
        if (galleries.length === 0) {
            getImages();
        }
    }, [galleries]);

    const handleImageClick = (src) => {
        setSelectedImage(src);
    };

    const handleClose = () => {
        setSelectedImage(null);
    };

    return <>
        <Helmet>
            <title>Gallery</title>
            <meta name="description" content=" Oasis Educational Institute" />
        </Helmet>
        
        <Breadcrumbs page="Gallery" label="Home" path="/" />
        <Container style={{ marginTop: '2%', marginBottom: '5%', padding: '20px' }}>
            <div className="gallery-container">
                <div className="gallery-grid m-6">
                    {galleries && galleries.map((image, index) => (
                        <div key={index} className="gallery-item">

                            <Image
                                id={image.file_id}
                                className="gallery-image"
                                clickImage={handleImageClick}
                            />

                        </div>
                    ))}
                </div>
                {selectedImage && (
                    <CSSTransition
                        in={!!selectedImage}
                        timeout={300}
                        classNames="modal"
                        unmountOnExit
                    >
                        <div className="modal-overlay" onClick={handleClose}>
                            <div className="modal-content" >
                                <img src={selectedImage} alt="full-size" className="full-size-image" />
                            </div>
                        </div>
                    </CSSTransition>
                )}
            </div>
        </Container>
    </>;
};

export default GalleryScreen;
